import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import NewMain from '../../headerone/newMain'




function Main() {


    
    const notificationList=[
        
       /* {title:'Agriculture Theory 1st Sem. Datesheet ETE December-2024',url:'/assets/img/new_images/examination_datesheet/Agriculture Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:'AHS Dept. Theory 1st Sem. Datesheet ETE December-2024  ',url:'/assets/img/new_images/examination_datesheet/AHS Dept. Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:'BA(Pol.)Sc. Theory 1st Sem. Datesheet ETE December-2024  ',url:'/assets/img/new_images/examination_datesheet/BA(Pol.)Sc. Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:'Engg. & CA Theory 1st Sem. Datesheet ETE December-2024  ',url:'/assets/img/new_images/examination_datesheet/Engg. & CA Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:'Law Deptt. Theory 1st Sem. Datesheet ETE December-2024  ',url:'/assets/img/new_images/examination_datesheet/Law Deptt. Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:'Pharmacy Theory 1st Sem. Datesheet ETE December-2024  ',url:'/assets/img/new_images/examination_datesheet/Pharmacy Theory 1st Sem. Datesheet ETE December-2024.pdf'},
        {title:' SBMC Deptt. Theory 1st Sem. Datesheet ETE December-2024 ',url:'/assets/img/new_images/examination_datesheet/SBMC Deptt. Theory 1st Sem. Datesheet ETE December-2024.pdf'},
 */
        
        
    ]


    return (
        <>
            <NewMain />
            <Bredcom title="Home" subtitle="Exam Notices" />


            <section className="project-detail">
                <div className="container">

                <h2 class="text-center"> Exam Notices
                </h2>

                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">
                                <div className="inner-column">
                                <ul class="details_list">

                                {notificationList.map((item, index) => (
                                   
                                     <li><a href={item.url}  target="_blank" rel="noopener"> {item.title} </a></li>

                                ))}

                                
                                </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main